export default "/images/61e5ec1efa5cdb119fe97027b430a3f0.avif";